// react-data-export (xlsx.js) throws "can't access property 'match', r.t is null" when a cell
// value is null/undefined — it cannot infer the cell type. Reports frequently have rows with a
// null field (e.g. NPP, student status, a date), which crashes the whole export.
//
// sanitizeExcelDataSet() coerces every cell value in a multiDataSet to a safe value ('' for
// null/undefined) without changing anything else. Wrap the dataSet passed to <ExcelSheet>:
//     <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="..." />
// Output is identical for non-null data — only missing values become empty cells.
export const sanitizeExcelDataSet = (dataSet) => {
    if (!Array.isArray(dataSet)) {
        return dataSet;
    }
    return dataSet.map(sheet => {
        if (!sheet || !Array.isArray(sheet.data)) {
            return sheet;
        }
        return {
            ...sheet,
            data: sheet.data.map(row => {
                if (!Array.isArray(row)) {
                    return row;
                }
                return row.map(cell => {
                    if (cell && typeof cell === 'object') {
                        return { ...cell, value: cell.value == null ? '' : cell.value };
                    }
                    // defensive: a bare null/undefined cell would also crash the writer
                    return cell == null ? { value: '' } : cell;
                });
            }),
        };
    });
};



// WEBPACK FOOTER //
// ./src/views/util/sanitizeExcel.js